module.exports = __webpack_public_path__ + "static/media/bt.79bfb084.png";